var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRulerMeasure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-ruler-measure",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12v2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12v3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12v3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12v3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12v2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5h18"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3v4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulerMeasure);
export default __webpack_public_path__ + "static/media/ruler-measure.381034d9.svg";
export { ForwardRef as ReactComponent };